import { Button } from "@/components/ui/button";
import { Plus, Minus } from "lucide-react";

interface ExpandCollapseButtonProps {
  expanded: boolean;
  onClick?: () => void;
  className?: string;
  testId?: string;
  tabIndex?: number;
  pointerEvents?: boolean;
  expandLabel?: string;
  collapseLabel?: string;
}

export function ExpandCollapseButton({
  expanded,
  onClick,
  className = "",
  testId,
  tabIndex,
  pointerEvents = true,
  expandLabel = "Expand",
  collapseLabel = "Collapse",
}: ExpandCollapseButtonProps) {
  const baseProps = {
    variant: "outline" as const,
    className: `shrink-0 text-muted-foreground ${!pointerEvents ? "pointer-events-none" : ""} ${className}`,
    "aria-expanded": expanded,
    ...(testId ? { "data-testid": testId } : {}),
    ...(tabIndex !== undefined ? { tabIndex } : {}),
    ...(onClick ? { onClick } : {}),
  };

  return (
    <>
      <Button
        {...baseProps}
        size="sm"
        className={`${baseProps.className} gap-1 hidden md:inline-flex`}
      >
        {expanded ? collapseLabel : expandLabel}
        {expanded ? <Minus className="h-4 w-4" /> : <Plus className="h-4 w-4" />}
      </Button>
      <Button
        {...baseProps}
        size="icon"
        className={`${baseProps.className} md:hidden`}
        {...(testId ? { "data-testid": `${testId}-mobile` } : {})}
      >
        {expanded ? <Minus className="h-4 w-4" /> : <Plus className="h-4 w-4" />}
      </Button>
    </>
  );
}
